module.exports = __webpack_public_path__ + "img/introduction02_workContents_03.c2939da9.png";